//import { uploadBase64 } from 'helpers/fb-storage';

export const create = async data => {
 const { phone, phones, email, emails } = data;
 if (!phones) data.phones = [phone];
 else {
  const isExist = phones.some(e => e === phone);
  if (!isExist) data.phones = [...phones, phone];
 }

 if (!emails) data.emails = [email];
 else {
  const isExist = emails.some(e => e === email);
  if (!isExist) data.emails = [...emails, email];
 }

 const newPerson = { ...data }; // docImg: await uploadBase64(data.docImg, 'DNIsRef')

 return newPerson;
};
